<template>
  <v-card flat class="rounded-20 mt-4" v-if="selectedOrderSession.kit_box_id">
    <v-card-title class="title-font"> SCAN GAUGE KIT </v-card-title>
    <v-card-text>
      <v-card flat max-width="256" class="mx-auto">
        <v-img height="75" contain :src="require('@/assets/sgk-gen2.png')" />
        <h3 class="text-center mt-2">
          {{ prettyKitName(selectedOrderSession.kit_box_id) }}
        </h3>
        <v-card-text
          class="text-center pb-0"
          v-if="scanGaugeKits?.length > 1 && !selectedOrderSession.associated"
        >
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn text small class="btn-primary" v-bind="attrs" v-on="on">
                <v-icon class="mr-2">$scanGaugeKitDark</v-icon>
                CHANGE KIT
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item
                v-for="(kit, index) in scanGaugeKits.filter(
                  (kit) => kit.kit_box_id !== selectedOrderSession.kit_box_id
                )"
                :key="index"
                @click="handleKitChange(kit.kit_box_id)"
              >
                <v-list-item-content>
                  <v-list-item-title>
                    {{ prettyKitName(kit.kit_box_id) }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-card-text>
      </v-card>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import client from "@/lib/ApiClient"

export default {
  name: "ScanGaugeKit",

  computed: {
    ...mapGetters(["scanGaugeKits", "selectedOrder", "selectedOrderSession"])
  },

  methods: {
    ...mapActions(["triggerReload"]),

    prettyKitName(kit_box_id) {
      const parts = kit_box_id.split("_")
      return `${parts[parts.length - 1]} (${parts[parts.length - 2]})`
    },

    async handleKitChange(kitBoxId) {
      await client.instance.orders.associateSession(
        this.selectedOrder.uid,
        this.selectedOrderSession.uid,
        {
          nc_session_id: this.selectedOrderSession.nc_session_id,
          kit_box_id: kitBoxId
        }
      )
      this.triggerReload("order")
    }
  }
}
</script>
